import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { AuctionDetailAuthenticatorStoreCotnext } from '../context/StoreContext'
import { AuctionDetailAuthenticatorStore } from '../store/interface'

export const useAuctionDetailAuthenticatorStore: UseStore<
  AuctionDetailAuthenticatorStore
> = selector => {
  return useContextStore(AuctionDetailAuthenticatorStoreCotnext, selector)
}

export const useAuctionDetailAuthenticatorStoreApi = () => {
  return useContextStoreApi(AuctionDetailAuthenticatorStoreCotnext)
}
